import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import Footer from '../footer';
// import SpinnerAnt from '../../kado/components/spinner-ant';
// import Spinner from '../../kado/components/spinner/spinner';
import { Label, Select, Spinner,SpinnerAnt  } from '../../kado/components';
import FetchAssessmentUUid from '../../actions/assessments/key/fetch';
import {FetchAssessmentClearError} from '../../actions/assessments/ass/common';
import I18, { i18Get } from '../../i18';
import Tostify from '../../kado/utils/tostify';
import Language from '../../kado/constant-files/language-options';
import Config from '../../cankado-config';
import renderHTML from 'react-render-html';
import TranslationAtions from '../../actions/translation';
import UrlCodes from "../../router/urlCodes";


import './login.css';
import './ios.css';


function getLanguages() {
    return  _.sortBy(Language.options, "label").map(x => ({
        ...x,
        label: (
            <Label> 
                
                <img src={`${Config.publicUrl}/locales/${x.value}/icon.png`} />
                <span className="language-text">{x.label} </ span>
            </Label>
        ),
    }));
}
class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            key: null,
            language: '',
            languagetext: '',
            auth: null,
            response: null,
        };
        this.selectLanguage = this.selectLanguage.bind(this);

    }
    componentDidMount(){
        
        var codeSplit = this.props.location.search.split('code=');
        if(codeSplit.length > 1){
            this.state.key = codeSplit[1]
	    this.setState({
		key:codeSplit[1]
	    })
            this.navigateToDashboard()

        }
    }
    onLangSelect(language) {
        this.state.languagetext = language;
    }

    handleChange() {
        this.setState({ key: this.refs.login.value})
        this.props.dispatch(FetchAssessmentClearError());
    }

    onEnterPress = (e) => {
        if (e.charCode === 13) {
            this.navigateToDashboard()
        }
    }

    navigateToDashboard() {
        if(this.state.key) {
            this.props.dispatch(FetchAssessmentUUid(this.state.key.toLowerCase()))
        } else {
            Tostify.showError(renderHTML(i18Get('Please enter the assessment code')));
        }
    }
    selectLanguage(lang) {
        if (lang) {
            this.props.dispatch(TranslationAtions.ResetLanguage(lang.value));
        }
    }


    render() {
        if (this.props.assessments.isFetchAssessmentUuid === 'FULFILLED' && this.props.assessments.assessmentUuid) {
            this.props.history.push(`/${UrlCodes.assessments}/` + this.props.assessments.assessmentUuid)
        }
        return (
            <div className="autoscroll h-100 w-100 noPadding">
                <div className="mam-login-container " style={{position:'relative'}}>
                    <div className="d-flex justify-content-end mt-3 position-absolute w-100 pt-3" style={{right:10 ,zIndex: 9}}>
                        <div className="languageSwitcher home-page d-print-none float-right">
                            <Select value={this.props.translations.language} backspaceRemoves={false} deleteRemoves={false} escapeClearsValue={false} searchable={false} clearable={false} onChange={this.selectLanguage} options={getLanguages()} />
                        </div>
                    </div>
                    <div className="login-form">
                        <div className="login-form-container">
                            <div className="mamebe-logo" style={{ margin: '0px  auto' }} />
                                <div className="mamebe-title"  style={{ margin: '0px auto' }}>Mamebe</div>
                                <div className="mamebe-illustration "  ></div>
                                <div className="mamebe-subtitle">
                                   {i18Get("Elevating chronic disease management for healthcare providers")}
                                </div>
                            {this.props.user.isCheckLoginComplete !== 'PENDING' ?
                                <div>
                                    {this.props.user.isCheckLoginComplete === 'FULFILLED' ?

                                        <div className="input-asses-wrapper">
                                           <div className="d-flex flex-column align-items-center">
                                                {/* <input type="text" value={this.state.key} ref="login" required onKeyPress={this.onEnterPress}  placeholder="Enter assessment code"  maxLength="5"/> */}
                                                <input
                                                        type="text"
                                                        value={this.state.key}
                                                        ref="login"
                                                        placeholder={i18Get('Enter assessment code')}
                                                        onKeyPress={this.onEnterPress}
                                                        onChange={this.handleChange.bind(this)}
                                                        className="mamebe-input"
                                                        maxLength="5"
                                                        />      
                                                     {/* <label className="asses-iplabel"> {renderHTML(i18Get('Assessment Code'))}</label> */}
                                            </div>
                                            <div className="text-center mt-1">
                                                <button type="button" onClick={this.navigateToDashboard.bind(this)}   className="btn waves-effect waves-light" type="submit">
                                                    { this.props.assessments.isFetchAssessmentUuid === 'PENDING' && 
                                                    <Spinner /> 
                                                    }
                                                    <span className="d-inline-block capital-first">
                                                        <I18 tkey="Let’s start"/>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                        :
                                        <div className="input-asses-failed">
                                            <span style={{ fontSize: 16, color: '#e53935' }}> <b><I18 tkey="We are facing some issues"/></b> </span> <br />
                                            <span>< I18 tkey="please refresh the page" /></span>
                                        </div>
                                    }
                                </div>
                                :
                                <div className="loader-wrapper">
                                    <SpinnerAnt />
                                </div>
                            }
                        </div>
                        {/* <div className="login-footer">
                            <Footer />
                        </div> */}
                        <div className="web-footer">
                            <Footer />
                        </div>
                    </div>
                    {/* <div className="login-bgblur"/> */}
                </div>
                {/* <div>
                    <Offline><div className="offline_toast">
                    <span>
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190.03 190.12"><title></title><path fill="#fff" d="M-154.07,363.72c-2.59-3.35-2.24-4.9.61-7.51,5.4-4.95,10.46-10.28,15.6-15.5,4-4.05,4.33-8.23,1.07-11.33s-7.11-2.58-11,1.27Q-234,416.89-320.29,503.18c-3.83,3.84-4.18,7.89-1.18,11s7.41,2.7,11.38-1.21c5.46-5.38,11-10.71,16.22-16.3,2.18-2.33,3.47-2.28,6-.29a92.67,92.67,0,0,0,56.34,20.55,98.1,98.1,0,0,0,31.79-4.68C-137.09,491.69-113.71,415.92-154.07,363.72ZM-169.21,372c1.73-1.89,2.82-1.69,4.14.33,2.14,3.3,4.42,6.52,7,10.36h-21.53C-175.87,378.87-172.44,375.52-169.21,372Zm-27.13,28.58a161.84,161.84,0,0,1,.68,36.25c-1,9.76-1,9.75-10.7,9.75h-36Zm-83.44,84.26c-1.48-1.17-.1-2,.64-2.78,2.79-3,5.59-6.05,9.11-9.85A119.41,119.41,0,0,0-259,496.68,72.14,72.14,0,0,1-279.79,484.81ZM-200,463.62c-3.3,11.4-7.34,22.46-15.3,31.56-8.93,10.21-18.58,10.19-27.47,0-7.94-9.14-11.89-20.23-15.11-31.65-.78-2.77.77-3,2.91-3,8.83.05,17.65,0,26.48,0,8.66,0,17.32.08,26-.05C-200,460.46-199.28,461.15-200,463.62Zm2.2,32.15a144.25,144.25,0,0,0,12.37-33.37,2.17,2.17,0,0,1,2.47-1.87c8,0,15.92,0,24.92,0C-167.77,477.47-180.61,489-197.8,495.77Zm42.2-49.15c-7.64-.23-15.3-.17-22.94,0-2.73.05-3.87-.52-3.51-3.57a180,180,0,0,0,0-42.29c-.36-3,.76-3.7,3.51-3.57,4,.19,8,0,12,0h5c10.39,0,10.47,0,12.31,10.28a81.3,81.3,0,0,1-1.41,35.08C-151.44,445.49-152.41,446.72-155.6,446.62Z" transform="translate(324.08 -326.79)"/><path fill="#fff" d="M-245.81,328.49c-43.32,8.36-73.49,41.47-77.81,85.34-2.09,21.21,3.2,40.93,14.55,59,.52.82,1,2.87,2.28,1.81a105.21,105.21,0,0,0,8.59-8.34c2-2.06-1.76-3.31-.87-5.42,10.53,1.26,12.91-9,19.46-13.57-7.9-.53-15.53-.64-23.16-.46-2.47.06-3.54-.77-4.15-3.07a83,83,0,0,1-.11-42.95c.69-2.64,1.92-3.4,4.52-3.31,5.33.18,10.66.05,16,.05,11.14,0,11,0,10,11.17a153.41,153.41,0,0,0,1,35.74c3.59-3.84,6.24-7.08,9.32-9.83a9.35,9.35,0,0,0,3.3-8.26c-.42-8.16.28-16.31.85-24.46.25-3.53,1.19-4.94,5-4.79,8.15.3,16.33.07,24.49.11,1.88,0,3.51-.15,5-1.68,3.66-3.85,7.5-7.53,11.39-11.4-.58-.64-.69-.87-.8-.87q-16.5,0-33-.06c-8.86,0-8.86,0-6.14-8.59,3.09-9.74,7.08-19,14.17-26.62,8.66-9.26,17.45-9.18,26.13.09,4.85,5.17,8.05,11.35,10.88,17.78.68,1.55.65,3.58,2.67,4.68,2.7-2.75,5.3-5.58,8.11-8.16,1.63-1.5,1.87-2.86.84-4.76-1.67-3.08-3.19-6.23-5.21-10.2,4.58,1.18,7.65,3.12,10.75,4.94,1.44.84,2.43,1.14,3.87-.24,2.85-2.75,6-5.21,9.39-8.14C-197.31,329.27-220.61,323.63-245.81,328.49ZM-272.48,381a2.41,2.41,0,0,1-2.72,2.19c-7.92-.07-15.84,0-24.68,0,9.44-16.83,22.36-28.27,39.52-35.12A145.87,145.87,0,0,0-272.48,381Z" transform="translate(324.08 -326.79)"/></svg></span>
                    <I18 tkey="You are offline"/>!</div></Offline>
                </div> */}
            </div>
        )
    }
}

export default withRouter(connect(store => ({
    user: store.user,
    translations: store.translations,
    assessments: store.assessments,
}))(Login));
